/*微信菜单 */
import { BaseModel } from '../BaseModel';

export class WxMenu extends BaseModel {
    Id:Number=0
    Aid:Number=0
    ParentId:Number=0
    TypeCode:string="click"
    TypeCodeTwo:string="wx-text"
    TypeName:string=""
    MenuName:string= ""
    Url:string=""
    AppId:string=""
    Remark:string=""
    SortId:string="10"
    Enable:string="1"
    TableName:string=""
    menuData:any = ''
    Individuation:Number=0
    IndividuationName:string=""
    sub_button:any= []
    momentDataArr:string=""
}